const tokens: string[] = [];
const addresses: string[] = [];
export const blacklist = [...tokens, ...addresses];
